export const FollowUpTimingEnum = Object.freeze({
  Days: 1,
  Hours: 2,
  Minutes: 3
});
